<script setup lang="ts">
import RepairSection from '@/components/rc/miner-repairs/repairs-sidebar/RepairSection.vue'
import { useRepairsContext } from '@/composables/rc/drawer-context'
import { usePartDetails } from '@/composables/rc/part-details'
import InitialDiagnosticSubsection from './diagnostic-result-subsections/InitialDiagnosticSubsection.vue'
import PartDamagesSubsection from './diagnostic-result-subsections/PartDamagesSubsection.vue'

const { minerId, selectedPart } = useRepairsContext()

const { initialDiagnostic } = usePartDetails(minerId, selectedPart)
</script>

<template>
  <RepairSection title="Diagnostic Result" :step="1" :active="!!initialDiagnostic">
    <InitialDiagnosticSubsection />
    <PartDamagesSubsection />
  </RepairSection>
</template>
